const CHUNK_RELOAD_KEY = "cc-chunk-reload";

const CHUNK_LOAD_PATTERN = /chunk load|loading (css )?chunk|chunkloaderror/i;

export function isChunkLoadFailure(reason: unknown): boolean {
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === "string"
      ? reason
      : String(reason);

  return CHUNK_LOAD_PATTERN.test(message);
}

export function reloadOnceOnChunkFailure(): void {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  console.warn("Chunk load error detected. Reloading...");
  window.location.reload();
}

function isStaticAssetUrl(url: string): boolean {
  return (
    url.includes("/static/") && (url.endsWith(".css") || url.endsWith(".js"))
  );
}

export function registerChunkLoadRecovery(): void {
  window.addEventListener("error", (event) => {
    const target = event.target as HTMLElement | null;
    const href =
      target instanceof HTMLLinkElement
        ? target.href
        : target instanceof HTMLScriptElement
        ? target.src
        : "";

    if (href && isStaticAssetUrl(href)) {
      reloadOnceOnChunkFailure();
      return;
    }

    if (isChunkLoadFailure(event.message)) {
      reloadOnceOnChunkFailure();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadFailure(event.reason)) {
      event.preventDefault();
      reloadOnceOnChunkFailure();
    }
  });
}
